import { MouseEvent, ReactNode } from 'react';

import classNames from 'classnames';

import { ListItem } from '@spotify/confidence-core-react';

import styles from './ArtifactListItem.module.css';

const Root = ({
  onClick,
  children,
  className,
  ariaDisabled,
}: {
  onClick?: (event: MouseEvent) => void;
  children: ReactNode;
  className?: string;
  ariaDisabled?: boolean;
}) => (
  <ListItem.Root
    className={classNames(styles.root, className)}
    onClick={onClick}
    interactive={!!onClick}
    role={ariaDisabled ? 'button' : undefined}
    tabIndex={ariaDisabled ? 0 : undefined}
    aria-disabled={ariaDisabled || undefined}
  >
    {children}
  </ListItem.Root>
);

const Icon = ({ children }: { children: ReactNode }) => (
  <ListItem.Icon>{children}</ListItem.Icon>
);

const Content = ({
  primary,
  secondary,
  className,
}: {
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
  className?: string;
}) => (
  <ListItem.Text
    disableText
    primary={<div className={styles.primary}>{primary}</div>}
    secondary={secondary && <div className={styles.secondary}>{secondary}</div>}
    className={className}
  />
);

const Action = ({ children }: { children: ReactNode }) => (
  <ListItem.Action className={styles.action}>{children}</ListItem.Action>
);

export const ArtifactListItem = {
  Root,
  Icon,
  Content,
  Action,
};
